import React from 'react';

const PanelClose = ({ width = 16, height = 16, className, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
      aria-hidden="true"
      {...rest}
    >
        <path
          d="M10 2V14M5.33333 6L7.33333 8L5.33333 10M3.33333 2H12.6667C13.403 2 14 2.59695 14 3.33333V12.6667C14 13.403 13.403 14 12.6667 14H3.33333C2.59695 14 2 13.403 2 12.6667V3.33333C2 2.59695 2.59695 2 3.33333 2Z"
          stroke="#999999"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
    </svg>
  );
};

export default PanelClose;
